import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, ArrowRight, Sparkles } from "lucide-react";
import { isMobile } from "../lib/api";
import { useAuth } from "../lib/auth";

const SHOWN_KEY = "zumroo_exit_popup_shown";

export default function ExitIntent() {
  const [open, setOpen] = useState(false);
  const { isAuthed, requireAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SHOWN_KEY)) return;
    let timer;
    const trigger = () => {
      if (sessionStorage.getItem(SHOWN_KEY)) return;
      sessionStorage.setItem(SHOWN_KEY, "1");
      setOpen(true);
    };
    if (isMobile()) {
      timer = setTimeout(trigger, 30000);
    } else {
      const onMouseLeave = (e) => { if (e.clientY <= 0) trigger(); };
      document.addEventListener("mouseleave", onMouseLeave);
      timer = setTimeout(trigger, 60000);
      return () => {
        document.removeEventListener("mouseleave", onMouseLeave);
        clearTimeout(timer);
      };
    }
    return () => clearTimeout(timer);
  }, []);

  if (!open) return null;

  const onClick = () => {
    setOpen(false);
    if (isAuthed) navigate("/listings");
    else requireAuth({ redirectTo: "/listings" });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[rgba(26,35,30,0.65)] backdrop-blur-sm"
      onClick={() => setOpen(false)}
      data-testid="exit-intent-popup"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative bg-white rounded-3xl max-w-md w-full p-7 sm:p-8 shadow-2xl"
      >
        <button
          onClick={() => setOpen(false)}
          className="absolute top-3 right-3 w-9 h-9 rounded-full hover:bg-[#F7F6F2] flex items-center justify-center text-[#5C6B62]"
          data-testid="exit-intent-close"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FBEFE9] text-[#C86646] text-xs font-bold tracking-wider uppercase">
            <Sparkles className="w-3 h-3" /> Wait — one more thing
          </div>
          <h3 className="mt-4 text-2xl sm:text-3xl font-bold tracking-tight text-[#1A231E]">
            See <span className="text-[#C86646]">fresh owner listings</span> in Pune
          </h3>
          <p className="mt-2 text-sm text-[#5C6B62]">
            Sign up free in 30 seconds. Browse without subscriptions — pay only when you unlock.
          </p>

          <button
            onClick={onClick}
            className="btn-primary w-full justify-center mt-5"
            data-testid="exit-intent-cta"
          >
            Get Started
            <ArrowRight className="w-4 h-4" />
          </button>
          <button
            onClick={() => setOpen(false)}
            className="block mx-auto mt-3 text-xs text-[#5C6B62] hover:text-[#1A231E]"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
